import React, { forwardRef } from 'react';
import MUIToggleButtonGroup, {
  ToggleButtonGroupProps as MUIToggleButtonGroupProps,
} from '@material-ui/lab/ToggleButtonGroup';

interface ToggleButtonGroupProps extends MUIToggleButtonGroupProps {}

const ToggleButtonGroup = forwardRef<
  React.HTMLAttributes<HTMLDivElement>,
  ToggleButtonGroupProps
>((props, ref) => {
  return (
    <MUIToggleButtonGroup {...props} ref={ref}>
      {props.children}
    </MUIToggleButtonGroup>
  );
});

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

export default ToggleButtonGroup;
